import React, { useState } from "react";
import toast from "react-hot-toast";

import { authApiService } from "../../../../api/api";
import { IDiscount, IDiscountCreateDto } from "../../../../types/discount.type";
import { IProduct } from "../../../../types/product.type";
import { ISelectsInput } from "../../../../types/selects.type";
import SelectChangeListInput from "../../../inputs/SelectChangeListInput/SelectChangeListInput";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  discount: IDiscount;
  products: IProduct[];
}

const EditDiscountForm: React.FC<Props> = (props) => {
  const [percent, setPercent] = useState<string>(props.discount.percent);
  const [products, setProducts] = useState<ISelectsInput[]>(
    props.discount.products.map((item) => ({
      id: item.id,
      name: item.name,
      secondSubName: item.price,
    }))
  );

  const onCountChange = (value: string) => {
    if (isNaN(Number(value))) {
      toast.error(`Поле очікує числове значення.
        Наприклад: ${(Math.random() * 100).toFixed(2)}`);
      return;
    }
    setPercent(value);
  };

  const onClickApply = async () => {
    try {
      const body: IDiscountCreateDto = {
        percent,
        products: products.map((item) => item.id),
      };

      const response = await authApiService.updateDiscount(
        props.discount.id,
        body
      );

      if (response) {
        props.onApply();
      }
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <EditInput
          value={percent}
          setValue={onCountChange}
          isRequired
          title="Відсоток"
        ></EditInput>
        <SelectChangeListInput
          isMultiSelect={true}
          values={products}
          title="Продукти"
          items={props.products.map((item) => ({
            id: item.id,
            name: item.name,
            secondSubName: item.price,
          }))}
          onClickActive={(value) =>
            setProducts((prevState) =>
              prevState.filter((item) => item.id !== value.id)
            )
          }
          onClickInactive={(value) =>
            setProducts((prevState) => [...prevState, { ...value }])
          }
        />
        {products.map((item, index) => (
          <ViewInput
            title={index === 0 ? "Обрані продукти" : ""}
            value={item.name}
            key={item.id}
          />
        ))}
      </div>
      <ModalBottomButtons
        onPressApply={onClickApply}
        onPressBack={props.onClose}
        isDeleteBackButton={true}
        applyTitle="Зберегти"
        backTitle="Видалити"
      />
    </div>
  );
};

export default EditDiscountForm;
